import React, { useState, useEffect, useRef, MouseEvent } from 'react';

import { StepWrapperBox } from '../styledComponent/Boxes.style';
import { AnswerButton } from '../styledComponent/Buttons.style';

import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../common/BaseStep';

interface PrivacyAgreementStepProps extends TitleAndDescriptionProps, StepWizardProps, StepProps {
  privacyButtonText: string;
}

export const PrivacyAgreementStep = (props: PrivacyAgreementStepProps) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [answer, setAnswer] = useState('');
  const { privacyButtonText, isActive } = props;
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isActive) {
      setAnswer('');
      return window.scrollTo(0, 0);
    }
  }, [isActive]);

  return (
    <>
      {isActive ? (
        <BaseStep {...props} isButtonDisabled={isButtonDisabled}>
          <StepWrapperBox>
            <AnswerButton
              id="selectPrivacyAgreement"
              ref={buttonRef}
              className={answer === privacyButtonText ? 'active' : ''}
              onClick={(event: MouseEvent<HTMLButtonElement>) => {
                event.stopPropagation();
                setAnswer(privacyButtonText);
                setIsButtonDisabled(false);
              }}
            >
              {privacyButtonText}
            </AnswerButton>
          </StepWrapperBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
};
